/** Вакансии сайта и отклики кандидатов (подпроект 12): «Команда → Вакансии» и «Команда → Отклики». */
export const ruTeamHiring = {
  tabs: { team: 'Сотрудники', vacancies: 'Вакансии', applications: 'Отклики' },
  saveFailed: 'Не сохранилось — попробуйте ещё раз',
  vacancies: {
    title: 'Вакансии',
    lead: 'Карточки раздела «Команда» на сайте. Опубликованные видны на сайте в этом порядке',
    add: 'Новая вакансия',
    empty: 'Вакансий пока нет',
    emptyHint: 'Добавьте вакансию — после публикации она появится на сайте в разделе «Команда»',
    published: 'На сайте',
    draft: 'Черновик',
    hot: 'Горящая',
    up: 'Выше',
    down: 'Ниже',
    edit: 'Изменить',
    remove: 'Удалить',
    removed: 'Вакансия «{title}» удалена',
    saved: 'Вакансия сохранена',
    dialogNew: 'Новая вакансия',
    dialogEdit: 'Вакансия',
    fields: {
      title: 'Название',
      direction: 'Направление',
      level: 'Уровень',
      formats: 'Формат работы',
      employment: 'Занятость',
      salary: 'Вилка',
      pitch: 'Зачем роль — одна фраза',
      tasks: 'Задачи',
      requirements: 'Требования',
      bonus: 'Будет плюсом',
      stack: 'Стек',
      hot: 'Горящая вакансия',
      published: 'Показывать на сайте',
    },
    listHint: 'Каждый пункт — с новой строки',
    publishHint: 'Для публикации нужны формат работы, фраза «зачем роль» и задачи',
    save: 'Сохранить',
    directions: { design: 'Дизайн', dev: 'Разработка', ai: 'AI', management: 'Менеджмент' },
    directionHint:
      'Выберите направление или впишите своё — оно появится в списке у следующих вакансий и на сайте',
    formats: { remote: 'Удалённо', hybrid: 'Гибрид' },
  },
  applications: {
    title: 'Отклики',
    lead: 'Отклики кандидатов из раздела «Команда» на сайте',
    empty: 'Откликов нет',
    emptyHint: 'Отклики с сайта появятся здесь, а вам придёт уведомление',
    all: 'Все',
    free: 'Свободный отклик',
    number: 'Отклик {number}',
    contact: 'Контакт',
    link: 'Ссылка',
    message: 'Сообщение',
    note: 'Заметка',
    notePlaceholder: 'Для команды: впечатление, договорённости, дата собеседования',
    saveNote: 'Сохранить заметку',
    statusChanged: 'Отклик {number}: «{status}»',
    statuses: { new: 'Новый', reviewing: 'Рассматриваем', invited: 'Пригласили', rejected: 'Отказ' },
    columns: { candidate: 'Кандидат', vacancy: 'Вакансия', status: 'Статус', at: 'Когда' },
  },
  notifications: {
    applicationTitle: 'Новый отклик: {name}',
    applicationFree: 'Свободный отклик — без вакансии',
  },
} as const;

export const ruHiringNotificationTypes = {
  typeOrgApplicationNew: 'Новый отклик кандидата',
  typeOrgApplicationNewHint: 'Кандидат откликнулся на вакансию в разделе «Команда» на сайте',
} as const;

export const ruHiringAudit = {
  actions: {
    org_vacancy: {
      created: 'Создана вакансия',
      changed: 'Изменена вакансия',
      removed: 'Удалена вакансия',
      restored: 'Возвращена вакансия',
    },
    org_application: { changed: 'Изменён отклик' },
  },
  entities: { org_vacancy: 'Вакансия', org_application: 'Отклик' },
  fields: { published: 'На сайте' },
} as const;
